module.exports = __webpack_public_path__ + "static/brucePage2-352eecb3500e8a935123e58af51335fc.png";